import { Dispatch, PropsWithChildren, SetStateAction, useEffect } from 'react'
import ProductNameInput from './ProductNameInput'
import {
  Control,
  FieldArrayWithId,
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormValues } from 'utils/type'
import { Me, Usage } from 'service/user'
import { ProductVideoSelector } from './ProductVideoSelector'
import { ProductImageSelector } from './ProductImageSelector'
import { ProductDetailImageSelector } from './ProdcutDetailImageSelector'
import { FileUploader } from './FileUploader'
import { LinkDetailType, PromptGroup } from 'service/list'
import classNames from 'classnames'
import { isMobile } from 'react-device-detect'
import { ProductShortForm } from './ProductShortForm'
import { transitionPlanName } from 'utils/common'
import { ProductScript } from './ProductScript'
import { useScriptStore } from 'store/useScriptStore'
import { ProductNotice } from './ProductNotice'
import { CreateVideoType } from '@/constant/videoTypes'

interface ProductItemProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  errors: FieldErrors<FormValues>
  setErrorText: Dispatch<React.SetStateAction<React.ReactNode>>
  userInfo: Me

  index: number
  usage: Usage | undefined
  error: {
    products: {
      link: boolean
      product: boolean
    }[]
    mainTitle: boolean
    thumbnail: boolean
  }
  selectedLink: LinkDetailType
  setError: any
  isAiName: boolean
  promptGroupList: PromptGroup[]

  translatePlanName: (planName: string) => string
  setPromptStatus: Dispatch<SetStateAction<boolean[]>>
  setToneTooltip: Dispatch<SetStateAction<boolean[]>>
  promptStatus: boolean[]
  toneTooltip: boolean[]
  createVideoType: CreateVideoType
}

const ProductItem = ({
  watch,
  index,
  control,
  errors,
  error,
  userInfo,
  setValue,
  usage,
  selectedLink,
  setError,
  isAiName,
  promptGroupList,
  translatePlanName,
  setPromptStatus,
  setToneTooltip,
  promptStatus,
  toneTooltip,
  createVideoType,
}: PropsWithChildren<ProductItemProps>) => {
  const { promptName, toneName, toggleModal, isAIGenerated } = useScriptStore()
  useEffect(() => {
    if (selectedLink) {
      setValue(`products.${index}.extensionCollectId`, selectedLink.id)
    }
  }, [selectedLink])
  return (
    <div
      className={classNames(
        'flex flex-col items-center w-[375px] md:w-full gap-1',
        { 'px-4': isMobile }
      )}
    >
      <p className="text-[18px] font-bold bg-[#2E343D] text-white w-full rounded-[6px] px-2">
        상품 {index + 1}
      </p>
      {/* 상품명 입력 */}
      <ProductNameInput
        index={index}
        control={control}
        errors={errors}
        error={error}
        watch={watch}
        setValue={setValue}
        usage={usage}
        userInfo={userInfo}
        selectedLink={selectedLink}
        setError={setError}
        isAiName={isAiName}
      />
      {/* 대본생성 & 편집 */}

      {!isAIGenerated && (
        <ProductScript
          index={index}
          watch={watch}
          setValue={setValue}
          userInfo={userInfo}
          control={control}
          promptGroupList={promptGroupList}
          setPromptStatus={setPromptStatus}
          setToneTooltip={setToneTooltip}
          promptStatus={promptStatus}
          toneTooltip={toneTooltip}
          translatePlanName={translatePlanName}
          selectedLink={selectedLink}
        />
      )}

      <ProductNotice createVideoType={createVideoType} />

      {/* 상품 영상 선택 */}
      <ProductVideoSelector
        selectedLink={selectedLink}
        index={index}
        watch={watch}
        setValue={setValue}
        createVideoType={createVideoType}
      />

      {/* 상품 이미지 선택 */}
      <ProductImageSelector
        selectedLink={selectedLink}
        index={index}
        setValue={setValue}
        watch={watch}
        createVideoType={createVideoType}
      />

      {/* 상품 상세 이미지 */}
      <ProductDetailImageSelector
        selectedLink={selectedLink}
        index={index}
        setValue={setValue}
        watch={watch}
        createVideoType={createVideoType}
      />

      {/* 이미지 업로드 */}

      {/* 
      <ProductShortForm
        watch={watch}
        index={index}
        setValue={setValue}
        userInfo={userInfo}
        control={control}
      /> */}
    </div>
  )
}

export default ProductItem
